export default "__VITE_ASSET__BpnXvZtI__"